module.exports = __webpack_public_path__ + "bbcf2c91032c930ef01565d8213f55d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/table/billlist_active.png
// module id = 747
// module chunks = 0